import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Dimmer, Message, Progress } from "semantic-ui-react";
import TitlePage from "./components/TitlePage";
import DomainScores from "./components/DomainScores";
import PulseQuestions from "./components/PulseQuestions";
import ScatterPlots from "./components/ScatterPlots";
import Insights from "./components/Insights";
import ActionPlanning from "./components/ActionPlanning";
import Questions from "./components/Questions";
import Appendix from "./components/Appendix";
import Sidebar from "./components/Sidebar";
import Debriefs from "./components/Debriefs";
import SummaryReportEmptyState from "./components/SummaryReportEmptyState";
import SummaryReportHeader from "../../components/SRHHeaders/SummaryReportHeader";
import { PageWrapper, PageContent, DimmerStyle, SidebarWrapper, EmptyStateWrapper } from "./style.js";
import { summaryReportOperations } from "./../../redux/summaryReport";
import { domainScoresOperations } from "./../../redux/domainScores";
import { keyDriversOperations } from "./../../redux/keyDrivers";
import { scatterPlotsOperations } from "./../../redux/scatterPlots";
import { bestWorstOperations } from "./../../redux/bestWorst";
import { questionsOperations } from "./../../redux/questions";
import { summaryReportTreeOperations } from "./../../redux/summaryReportTree";
import { navActions } from "./../../redux/nav";
import { filterActions } from "./../../redux/filters";
import axios from "axios";
import parse from "url-parse";
import moment from "moment";
import _ from "lodash";
import ReactGA from "react-ga";
import { benchmarksOperations } from "../../redux/benchmarks";
ReactGA.initialize("UA-52754256-15");

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

class SummaryReport extends Component {
  constructor(props) {
    super(props);
    const id = this.props.match ? this.props.match.params.id : this.props.id;
    this.state = {
      id,
      unit: parse(this.props.location.search, true).query.unit,
      token: this.props.sharedSummaryReport ? this.props.sharedSummaryReport.token : undefined,
      loaded: false,
      showInlineValuesOnDonuts: true,
      showAllQuestions: false,
      showAllQuestionPercentiles: true,
      showAllQuestionInlineValues: true,
      landscape: null,
    };
    this.googleEventGenerateReport = this.googleEventGenerateReport.bind(this);
    this.setUnit = this.setUnit.bind(this);
    if (id) {
      this.loadData(id);
    }
    //if (this.props.user.isLoggedIn) {
      this.props.dispatch(summaryReportTreeOperations.fetchSummaryReportTree(id));
    //}
    this.toggleShowAllQuestions = this.toggleShowAllQuestions.bind(this);
    this.toggleShowAllQuestionPercentiles = this.toggleShowAllQuestionPercentiles.bind(this);
  }

  googleEventGenerateReport() {
    const { datasetName, survey } = this.props.summaryReport.summaryReport;
    const { unit } = this.state;
    if (unit) {
      ReactGA.event({
        category: datasetName,
        action: "generate_unit_summary_report",
        label: `${survey}_Summary_Report_${datasetName}_${unit}_${moment().format("MMDDYYYY")}.pdf`,
      });
    } else {
      ReactGA.event({
        category: datasetName,
        action: "generate_hospital_summary_report",
        label: `${survey}_Summary_Report_${datasetName}_${moment().format("MMDDYYYY")}.pdf`,
      });
    }
  }

  setId(id) {
    this.setState({ id });
    this.loadData(id);
  }

  setUnit(unitIn) {
    this.props.dispatch(navActions.closeSettings());

    const { unit } = this.state;
    const params = parse(this.props.location.search, true).query;
    if (unitIn === "all") {
      delete params.unit;
    } else {
      params.unit = encodeURIComponent(unitIn); //unitIn.replace(/&/g, "%26");
    }

    this.props.history.push({
      search: `?${_.map(_.toPairs(params), function (param) {
        return `${param[0]}=${param[1]}`;
      }).join("&")}`,
    });

    if (unitIn === "all") {
      unitIn = undefined;
    }
    if (unitIn !== unit) {
      this.setState({ unit: unitIn });
      this.props.dispatch(questionsOperations.clear());
      this.props.dispatch(filterActions.clearFilters());
    }
  }

  loadData(id) {
    const { sharedSummaryReport } = this.props;
    const { token } = this.state;
    const options = { token };
    if (sharedSummaryReport) {
      options.sharedSummaryReport = sharedSummaryReport;
    }
    this.props.dispatch(summaryReportOperations.fetchSummaryReport(id, options));
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { summaryReport, domainScores, scatterPlots, bestWorst, keyDrivers } = nextProps;
    const state = {};
    if (summaryReport.fetched && prevState.landscape === null) {
      state.landscape = summaryReport.summaryReport.configuration.default_landscape;
    }
    if (summaryReport.fetched && summaryReport.summaryReport.unit) {
      state.unit = summaryReport.summaryReport.unit;
    }
    if (!nextProps.questions.fetched && !nextProps.questions.fetching && prevState.showAllQuestions) {
      state.showAllQuestions = false;
    }
    if (!keyDrivers.fetched && summaryReport.fetched && summaryReport.summaryReport.system === "NYU") {
      state.showInlineValuesOnDonuts = true;
      state.showAllQuestionInlineValues = true;
    }
    if (
      summaryReport.fetched &&
      domainScores.fetched &&
      scatterPlots.fetched &&
      bestWorst.fetched &&
      keyDrivers.fetched &&
      !prevState.loaded
    ) {
      state.loaded = true;
    }
    return state;
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      summaryReport,
      domainScores,
      questions,
      scatterPlots,
      bestWorst,
      keyDrivers,
      sharedSummaryReport,
      filters,
      appliedBenchmark
    } = this.props;
    const { unit, token } = this.state;
    const error =
      summaryReport.error || domainScores.error || scatterPlots.error || bestWorst.error || keyDrivers.error;
    const isPulse = summaryReport.summaryReport.survey && summaryReport.summaryReport.survey.indexOf("Pulse") > -1;

    if (summaryReport.fetched && !error) {
      const options = { token, ...summaryReport.summaryReport };
      if (options.appliedBenchmark !== appliedBenchmark) {
        this.loadData(options.id);
      }
      if (!appliedBenchmark) {
        const workSettingBenchmarksArray = options.workSettingBenchmarks.split(',').map(str => str.trim());
        const datasetBenchmarksArray = options.datasetBenchmarks.split(',').map(str => str.trim());
        const benchmark = unit ? workSettingBenchmarksArray[0] : datasetBenchmarksArray[0];
        this.props.dispatch(benchmarksOperations.applyBenchmark(benchmark));
      }
      if (unit) {
        options.units = [unit];
      } else if (summaryReport.summaryReport.unit) {
        options.units = [summaryReport.summaryReport.unit];
      }
      if (filters && filters.unit && filters.unit.length === 1) {
        options.units = filters.unit;
      }
      const tableId = `${summaryReport.summaryReport.datasetId}_${summaryReport.summaryReport.resultSetId}`;
      if ((!prevProps.summaryReport.fetched && summaryReport.fetched) || prevState.unit !== this.state.unit || prevProps.filters !== filters) {
        this.googleEventGenerateReport();
        this.props.dispatch(keyDriversOperations.fetchKeyDrivers(tableId, options));
        this.props.dispatch(domainScoresOperations.clearProgress());
        this.props.dispatch(questionsOperations.clear());
        this.props.dispatch(scatterPlotsOperations.clearProgress());
        this.props.dispatch(bestWorstOperations.clearProgress());
      }
      if (!prevProps.keyDrivers.fetched && keyDrivers.fetched) {
        if (isPulse) {
          this.props.dispatch(questionsOperations.fetchQuestions(tableId, options));
        } else {
          this.props.dispatch(domainScoresOperations.fetchDomainScores(tableId, options));
        }
      }
      if (
        (!isPulse && !prevProps.domainScores.fetched && domainScores.fetched) ||
        (isPulse && !prevProps.questions.fetched && questions.fetched)
      ) {
        this.props.dispatch(scatterPlotsOperations.fetchScatterPlots(tableId, options));
      }
      if (!prevProps.scatterPlots.fetched && scatterPlots.fetched) {
        this.props.dispatch(bestWorstOperations.fetchBestWorst(tableId, options));
      }
    }
    const justLoaded =
      summaryReport.fetched &&
      ((!isPulse && domainScores.fetched) || (isPulse && questions.fetched)) &&
      scatterPlots.fetched &&
      bestWorst.fetched &&
      keyDrivers.fetched &&
      !summaryReport.error &&
      !domainScores.error &&
      !questions.error &&
      !scatterPlots.error &&
      !bestWorst.error &&
      !keyDrivers.error &&
      (!prevProps.summaryReport.fetched ||
        (!isPulse && !prevProps.domainScores.fetched) ||
        (isPulse && !prevProps.questions.fetched) ||
        !prevProps.scatterPlots.fetched ||
        !prevProps.bestWorst.fetched ||
        !prevProps.keyDrivers.fetched);
    const justFailed =
      !prevProps.summaryReport.error &&
      !prevProps.domainScores.error &&
      !prevProps.questions.error &&
      !prevProps.scatterPlots.error &&
      !prevProps.bestWorst.error &&
      !prevProps.keyDrivers.error &&
      error;
    if (justLoaded && sharedSummaryReport) {
      axios.post(`/api/shared-summary-reports/${sharedSummaryReport.token}/view`);
    }
    if (justFailed && sharedSummaryReport) {
      axios.post(`/api/shared-summary-reports/${sharedSummaryReport.token}/error`);
    }
  }

  toggleShowInlineValuesOnDonuts = () => {
    this.setState({ showInlineValuesOnDonuts: !this.state.showInlineValuesOnDonuts });
  };

  toggleShowAllQuestions() {
    const { summaryReport, sharedSummaryReport, questions } = this.props;
    const { showAllQuestions, unit } = this.state;
    if (showAllQuestions) {
      this.setState({ showAllQuestions: false });
    } else {
      if (!questions.fetched && !questions.fetching) {
        const options = { ...summaryReport.summaryReport };
        if (unit) {
          options.units = [unit];
        }
        if (sharedSummaryReport) {
          options.token = sharedSummaryReport.token;
        }
        const tableId = `${summaryReport.summaryReport.datasetId}_${summaryReport.summaryReport.resultSetId}`;
        this.props.dispatch(questionsOperations.fetchQuestions(tableId, options));
      }
      this.setState({ showAllQuestions: true });
    }
  }

  toggleShowAllQuestionPercentiles() {
    this.setState({ showAllQuestionPercentiles: !this.state.showAllQuestionPercentiles });
  }

  toggleShowAllQuestionInlineValues = () => {
    this.setState({ showAllQuestionInlineValues: !this.state.showAllQuestionInlineValues });
  };

  render() {
    const {
      summaryReport,
      domainScores,
      questions,
      scatterPlots,
      bestWorst,
      keyDrivers,
      sharedSummaryReport,
      summaryReportTree,
      user,
      appliedBenchmark
    } = this.props;
    const {
      workSettings,
      survey,
      actualSurvey,
      configuration,
      enableDebriefer,
      forceFacilityDebriefer,
      unitsWithoutReportFlag,
      workSettingReports,
      workSettingsNoReport,
      datasetId,
      suppressed,
    } = summaryReport.summaryReport;
    const {
      id,
      loaded,
      showAllQuestions,
      showInlineValuesOnDonuts,
      showAllQuestionPercentiles,
      showAllQuestionInlineValues,
      landscape,
    } = this.state;

    const isPulse = survey && survey.indexOf("Pulse") > -1;
    const debrieferUsable = enableDebriefer && user && user.isLoggedIn;

    const unitName = this.state.unit;
    const debrieferUnitName = forceFacilityDebriefer ? summaryReport.summaryReport.datasetName : this.state.unit;

    let unit;
    if (unitName) {
      let responseCount;
      let responseRate;
      for (let i = 0; i < workSettings.length; i++) {
        const workSetting = workSettings[i];
        if (workSetting.unit === unitName) {
          responseCount = workSetting.count;
          responseRate = workSetting.response_rate;
        }
        if (summaryReport.summaryReport.responseRate && !getParameterByName("unit")) {
          responseRate = summaryReport.summaryReport.responseRate;
        }
      }
      unit = {
        name: unitName,
        responseCount,
        responseRate,
      };
    }

    const breadcrumbs = [];
    if (summaryReport.summaryReport.datasetName) {
      breadcrumbs.push(summaryReport.summaryReport.datasetName);
      if (unitName) {
        breadcrumbs.push(unitName);
      } else {
        breadcrumbs.push("all");
      }
    }

    let unitHasNoReport = false;
    if (workSettingsNoReport && workSettingsNoReport.length) {
      const selectedUnit = _.find(workSettingsNoReport, obj => obj.value === unitName);
      if (selectedUnit) {
        unitHasNoReport = true;
      }
    } else if (datasetId && suppressed) {
      unitHasNoReport = true;
    }

    const noReport = !id;
    const ready =
      noReport ||
      (summaryReport.fetched &&
        ((!isPulse && domainScores.fetched) || (isPulse && questions.fetched)) &&
        scatterPlots.fetched &&
        bestWorst.fetched &&
        keyDrivers.fetched &&
        summaryReportTree.fetched);
    const error =
      summaryReport.error ||
      domainScores.error ||
      questions.error ||
      scatterPlots.error ||
      bestWorst.error ||
      keyDrivers.error;

    let benchmarkFootnote = "";

    let domainScoresRootConfiguration;
    let domainScoresPageConfiguration;
    let scatterplotsConfiguration;
    let displayActionPlanning;

    let domainScoresPageCount = 1;
    let scatterPlotPageCount = 2;
    let insightsPageCount = 1;
    let actionPlanningPageCount = 0;
    let allSurveyItemsPageCount = 0;

    if (ready && !noReport) {
      let benchmarkType = appliedBenchmark.includes("facility") ? "facilities" : "work settings";
      const benchmarkYear = appliedBenchmark.substring(0, 4);
      const benchmarkQuarter = appliedBenchmark.substring(5, 7).toUpperCase();
      let benchmarkRegion = "";
      if (/_us(_|$)/.test(appliedBenchmark)) {
        benchmarkRegion = "US";
      } else if (/_uk(_|$)/.test(appliedBenchmark)) {
        benchmarkRegion = "UK";
      } else if (/_ca(_|$)/.test(appliedBenchmark)) {
        benchmarkRegion = "Canadian";
      }
      
      if (benchmarkRegion === "UK") {
        benchmarkType = "work settings";
      }
      benchmarkFootnote = `Benchmark percentiles are based on a ${benchmarkRegion} benchmark of ${benchmarkType} dated: ${benchmarkYear}${
        /Q\d/.test(benchmarkQuarter) ? ` ${benchmarkQuarter}` : ""
      }.`;

      domainScoresRootConfiguration = configuration.domain_scores;
      if (domainScoresRootConfiguration && domainScoresRootConfiguration.pages) {
        if (!landscape && domainScoresRootConfiguration.pages.portrait) {
          domainScoresPageConfiguration = domainScoresRootConfiguration.pages.portrait;
        }
        if (landscape && domainScoresRootConfiguration.pages.landscape) {
          domainScoresPageConfiguration = domainScoresRootConfiguration.pages.landscape;
        }
      }

      if (isPulse && domainScoresPageConfiguration) {
        domainScoresPageCount = domainScoresPageConfiguration.length;
      }
      if (domainScoresRootConfiguration && domainScoresRootConfiguration.hide) {
        domainScoresPageCount = 0;
      }

      scatterplotsConfiguration = configuration.scatterplots;

      if (
        scatterPlots.scatterPlots.length > 0 &&
        _.filter(scatterPlots.scatterPlots[1][0].data.points, function (point) {
          return point.key !== "Other";
        }).length > 1
      ) {
        scatterPlotPageCount = 2;
      } else {
        scatterPlotPageCount = 1;
      }
      if (scatterplotsConfiguration && scatterplotsConfiguration.hide) {
        scatterPlotPageCount = 0;
      }

      const hasActionPlans = (data) => data && _.find(data, a => a.action)

      displayActionPlanning = configuration.action_planning && configuration.action_planning.display 
        && (configuration.key === 'SUTTER_Pulse_2019' || configuration.key === 'SUTTER_Pulse_2020'
        || (summaryReport.summaryReport.showActionPlan && (hasActionPlans(bestWorst.bestWorst.cultureWorst) || hasActionPlans(bestWorst.bestWorst.engagementWorst))));

      if (summaryReport.summaryReport.actualSurvey.indexOf('TRINITY_2020') >= 0 && summaryReport.summaryReport.showActionPlan)
        displayActionPlanning = true;

      if (displayActionPlanning) {
        actionPlanningPageCount = 3;
      } else {
        if (bestWorst.bestWorst && (summaryReport.summaryReport.showCultureActionPlans || summaryReport.summaryReport.showEngagementActionPlans)) {
          displayActionPlanning = true;
          const engagementActionPlanCount = summaryReport.summaryReport.showEngagementActionPlans || 0;
          const cultureActionPlanCount = summaryReport.summaryReport.showCultureActionPlans || 0;

          //filter only opportunities with plans
          const cultureActions = _.filter(bestWorst.bestWorst.cultureWorst, o => o.action);
          const engagementActions = _.filter(bestWorst.bestWorst.engagementWorst, o => o.action);

          //actual count is requested amount or fewer if only lesser amounts are available
          const actualCultureCount = Math.min(cultureActionPlanCount, cultureActions.length);
          const actualEnagementCount = Math.min(engagementActionPlanCount, engagementActions.length);

          //total pages is total available or requests whichever is lower
          actionPlanningPageCount = actualCultureCount + actualEnagementCount;
        }

      }

      if (showAllQuestions) {
        if (configuration.custom_questions && Array.isArray(configuration.custom_questions.pages)) {
          allSurveyItemsPageCount = configuration.custom_questions.pages.length;
        } else if (survey === "SCORE") {
          if (summaryReport.summaryReport.version.major < 2) {
            allSurveyItemsPageCount = 5;
          } else {
            if (summaryReport.summaryReport.system === "NYU") {
              allSurveyItemsPageCount = 3;
            } else {
              allSurveyItemsPageCount = 6;
            }
          }
        } else if (actualSurvey === "AMITA") {
          allSurveyItemsPageCount = 2;
        } else if (actualSurvey === "NonClinical") {
          allSurveyItemsPageCount = 6;
        } else if (actualSurvey === "AMITA_v2.0.0") {
          allSurveyItemsPageCount = 3;
        } else {
          if (summaryReport.summaryReport.version.major < 2) {
            allSurveyItemsPageCount = 3;
          } else {
            allSurveyItemsPageCount = 4;
          }
        }
      }
    }

    const domainScoresPageNumber = 2;
    const scatterPlotsPageNumber = domainScoresPageNumber + domainScoresPageCount;
    const insightsPageNumber = scatterPlotsPageNumber + scatterPlotPageCount;
    const actionPlanningPageNumber = insightsPageNumber + insightsPageCount;
    const allSurveyItemsPageNumber = actionPlanningPageNumber + actionPlanningPageCount;
    const appendixPageNumber = allSurveyItemsPageNumber + allSurveyItemsPageCount;



    let units = Array.isArray(workSettingReports) ? workSettingReports : [];
    if (unitsWithoutReportFlag && workSettingsNoReport && workSettingsNoReport.length) {
      units = units.concat(workSettingsNoReport);
    }

    const noAssignedReports = summaryReportTree.summaryReportTree && summaryReportTree.summaryReportTree.length === 0;
    const noSharedWorkSettings = !units || (units && units.length === 0);
    const noAccess = noAssignedReports && noSharedWorkSettings;
  
    return (
      <React.Fragment>
        <div id="dont-print-message">Please use the "Download/Print report" button to get a printable report.</div>
        <PageWrapper id="dont-print">
          <SummaryReportHeader
            {...this.props}
            unit={unitName}
            units={units}
            ready={ready}
            setUnit={this.setUnit}
            breadcrumbs={breadcrumbs}
            reportSelect={summaryReport.summaryReport.reportSelect}
            summaryReportTree={summaryReportTree.summaryReportTree}
            user={user}
            noReport={noReport}
            summaryReport={summaryReport.summaryReport}
            landscape={landscape}
            sharedSummaryReport={sharedSummaryReport}
          />
          {error && (
            <Container>
              <Message
                error
                header="We encountered an error. Try reloading the page."
                // content={summaryReport.error.data.response}
              />
            </Container>
          )}
          {!error && noReport && !noAccess && (
            <div
              style={{
                textAlign: "center",
                marginTop: "80px",
                fontSize: "18px",
                color: "#aaa",
              }}
            >
              No report selected. Please select one to view data.
            </div>
          )}
          {(noAccess || unitHasNoReport) && (
            ready && (
              <EmptyStateWrapper>
                <SummaryReportEmptyState type={noAccess ? 'noAccess' : 'noReport'} />
              </EmptyStateWrapper>
            )
          )}
          {
            !error &&
            !noReport && 
            (summaryReport.fetched || (!summaryReport.fetched && !scatterPlots.fetched)) && (
              <Dimmer.Dimmable as={PageContent}>
                <Dimmer as={DimmerStyle} active className={ready ? "hide" : ""}>
                  <div style={{ width: "600px", margin: "auto" }}>
                    <div style={{ marginBottom: "7px", textAlign: "left" }}>Loading report...</div>
                    <Progress
                      percent={Math.min(
                        Math.floor(
                          ((summaryReport.fetched && !loaded ? 100 : 0) +
                          (!isPulse && domainScores.fetched ? 100 : 0) +
                          (isPulse && questions.fetched ? 100 : 0) +
                          (scatterPlots.fetched ? 100 : 0) +
                          (bestWorst.fetched ? 100 : 0) +
                          (summaryReportTree.fetched ? 100 : 0) + 
                          (keyDrivers.fetched ? 100 : 0)) /
                          (loaded ? 6 : 7)
                        ),
                        100
                      )}
                      active
                      progress="percent"
                      color="orange"
                    />
                  </div>
                </Dimmer>
                {(!noAccess && !unitHasNoReport) && (
                  <SidebarWrapper landscape={landscape}>
                    <div className="fill">
                      <div id="divToPrint">
                        <TitlePage unit={unit} ready={ready} landscape={landscape} />
                        {domainScoresRootConfiguration && !domainScoresRootConfiguration.hide && (
                          <React.Fragment>
                        {domainScoresRootConfiguration && domainScoresRootConfiguration.type === "BARS" && (
                          <Questions
                            unit={unit}
                            ready={ready}
                            sharedSummaryReport={sharedSummaryReport}
                            showAllQuestions={true}
                            toggleShowAllQuestions={this.toggleShowAllQuestions}
                            showAllQuestionPercentiles={true}
                            toggleShowAllQuestionPercentiles={this.toggleShowAllQuestionPercentiles}
                            showAllQuestionInlineValues={showAllQuestionInlineValues}
                            toggleShowAllQuestionInlineValues={this.toggleShowAllQuestionInlineValues}
                            templateConfiguration={domainScoresRootConfiguration}
                            pageConfiguration={domainScoresPageConfiguration}
                            page={domainScoresPageNumber}
                            landscape={landscape}
                          />
                        )}
                        
                        {(!domainScoresRootConfiguration || !domainScoresRootConfiguration.type) &&
                        !isPulse && (
                          <DomainScores
                            unit={unit}
                            ready={ready}
                            sharedSummaryReport={sharedSummaryReport}
                            page={domainScoresPageNumber}
                            configuration={configuration}
                            benchmarkFootnote={benchmarkFootnote}
                            landscape={landscape}
                          />
                        )}
                        {(!domainScoresRootConfiguration || !domainScoresRootConfiguration.type) &&
                        isPulse && (
                      <PulseQuestions
                        unit={unit}
                        ready={ready}
                        sharedSummaryReport={sharedSummaryReport}
                        page={domainScoresPageNumber}
                        benchmarkFootnote={benchmarkFootnote}
                        showInlineValuesOnDonuts={showInlineValuesOnDonuts}
                        landscape={landscape}
                      />
                    )}
                      </React.Fragment>
                    )}
                    {(scatterplotsConfiguration && !scatterplotsConfiguration.hide &&
                      <ScatterPlots
                        unit={unit}
                        ready={ready}
                        page={scatterPlotsPageNumber}
                        landscape={landscape}
                        configuration={configuration}
                      />
                    )}
                    {!/SUTTER_Pulse_PhysicianAmb/.test(actualSurvey) && !/TRINITY_2020_PEEK/.test(actualSurvey) && !/SRH_Pulse_2022/.test(actualSurvey) && !/SRH_Pulse_2022a/.test(actualSurvey) && !/VIZ_BNCHMRK_Pulse_2022/.test(actualSurvey) && !/BILLINGS_Pulse_2022/.test(actualSurvey) && !/BILLINGS_Pulse_Magnet_2022_3/.test(actualSurvey) && !/QUEENS_Pulse_Magnet_2022/.test(actualSurvey)  && !/RISE_Pulse_2023/.test(actualSurvey) && (
                      <Insights
                        unit={unit}
                        ready={ready}
                        showInlineValuesOnDonuts={showInlineValuesOnDonuts}
                        toggleShowInlineValuesOnDonuts={this.toggleShowInlineValuesOnDonuts}
                        page={insightsPageNumber}
                        landscape={landscape}
                      />
                    )}
                    {displayActionPlanning && (
                      <ActionPlanning
                        unit={unit}
                        ready={ready}
                        page={actionPlanningPageNumber}
                        landscape={landscape}
                        configuration={configuration.action_planning}
                      />
                    )}
                    {(!isPulse && !/TRINITY_2020_PEEK/.test(actualSurvey) || (isPulse && configuration.custom_questions && configuration.custom_questions.all_survey_items_button)) && (
                      <Questions
                        unit={unit}
                        ready={ready}
                        sharedSummaryReport={sharedSummaryReport}
                        showAllQuestions={showAllQuestions}
                        toggleShowAllQuestions={this.toggleShowAllQuestions}
                        showAllQuestionPercentiles={showAllQuestionPercentiles}
                        toggleShowAllQuestionPercentiles={this.toggleShowAllQuestionPercentiles}
                        showAllQuestionInlineValues={showAllQuestionInlineValues}
                        toggleShowAllQuestionInlineValues={this.toggleShowAllQuestionInlineValues}
                        templateConfiguration={configuration}
                        page={allSurveyItemsPageNumber}
                        landscape={landscape}
                      />
                    )}
                      {!unit &&
                        !/TRINITY/.test(actualSurvey) &&
                        !/SUTTER_Pulse/.test(actualSurvey) && (
                            <Appendix unit={unit} ready={ready} page={appendixPageNumber} landscape={landscape} />
                          )}
                      </div>
                    </div>
                    <Sidebar
                      unit={unitName ? unitName : "all"}
                      showAllQuestions={showAllQuestions}
                      showInlineValuesOnDonuts={showInlineValuesOnDonuts}
                      toggleShowInlineValuesOnDonuts={this.toggleShowInlineValuesOnDonuts}
                      toggleShowAllQuestions={this.toggleShowAllQuestions}
                      showAllQuestionPercentiles={showAllQuestionPercentiles}
                      toggleShowAllQuestionPercentiles={this.toggleShowAllQuestionPercentiles}
                      showAllQuestionInlineValues={showAllQuestionInlineValues}
                      toggleShowAllQuestionInlineValues={this.toggleShowAllQuestionInlineValues}
                      configuration={configuration}
                    />
                  </SidebarWrapper>
                )}
              </Dimmer.Dimmable>
            )}
          {debrieferUsable && <Debriefs unit={debrieferUnitName} sharedSummaryReport={sharedSummaryReport}></Debriefs>}
        </PageWrapper>
      </React.Fragment>
    );
  }
}

export default connect(store => {
  return {
    summaryReport: store.summaryReport,
    domainScores: store.domainScores,
    scatterPlots: store.scatterPlots,
    bestWorst: store.bestWorst,
    keyDrivers: store.keyDrivers,
    questions: store.questions,
    summaryReportTree: store.summaryReportTree,
    user: store.user,
    filters: store.filters,
    appliedBenchmark: store.benchmarks.appliedBenchmark
  };
})(SummaryReport);



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/index.jsx